import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
    mediaGalleryGridStyle,
    mediaGalleryStyle,
    mediaGallerySubstageStyle,
    substageMediaGalleryStyle
} from './styles/MediaGallery.styles';
import { RemoteParticipant, LocalVideoStream, RemoteVideoStream, VideoStreamRenderer, VideoStreamRendererView } from '@azure/communication-calling';
import { utils } from '../Utils/Utils';
import LocalStreamMedia from './LocalStreamMedia';
import RemoteStreamMedia from './RemoteStreamMedia';
import { SelectionState } from 'core/RemoteStreamSelector';
import { ActionButton, Stack, TextField, values } from '@fluentui/react';
import { Constants } from '../core/constants';
import { ParticipantModel, ParticipantInfo, uriGid, allowUser, LeaveInterviewCall, uriCode, Ratings, UpdateStatus, UpdateRatings, InterviewerDataModel, CheckNullEmptyUndefined, Interpretation } from 'Utils/participantInfo';
//import { ParticipantModel, ParticipantInfo} from 'Utils/participantInfo';
import { chatAdd, GetChatList } from 'Utils/chataddapi';

import { connection, send, SetInput } from 'Utils/SignalRConnection';
import AceEditor from 'react-ace';
//import * as ace from 'ace-builds/src-noconflict/ace'
//ace.config.set('basePath', "https://unpkg.com/ace-builds@1.4.6/src-noconflict")
import "ace-builds/src-noconflict/mode-abap";
import "ace-builds/src-noconflict/mode-abc";
import "ace-builds/src-noconflict/mode-actionscript";
import "ace-builds/src-noconflict/mode-ada";
import "ace-builds/src-noconflict/mode-alda";
import "ace-builds/src-noconflict/mode-apache_conf";
import "ace-builds/src-noconflict/mode-apex";

import "ace-builds/src-noconflict/mode-applescript";
import "ace-builds/src-noconflict/mode-aql";
import "ace-builds/src-noconflict/mode-asciidoc";
import "ace-builds/src-noconflict/mode-asl";
import "ace-builds/src-noconflict/mode-assembly_x86";
import "ace-builds/src-noconflict/mode-autohotkey";
import "ace-builds/src-noconflict/mode-batchfile";
import "ace-builds/src-noconflict/mode-c_cpp";
import "ace-builds/src-noconflict/mode-c9search";
import "ace-builds/src-noconflict/mode-cirru";
import "ace-builds/src-noconflict/mode-clojure";
import "ace-builds/src-noconflict/mode-cobol";
import "ace-builds/src-noconflict/mode-coffee";
import "ace-builds/src-noconflict/mode-coldfusion";
import "ace-builds/src-noconflict/mode-crystal";
import "ace-builds/src-noconflict/mode-csharp";
import "ace-builds/src-noconflict/mode-csound_document";
import "ace-builds/src-noconflict/mode-csound_orchestra";
import "ace-builds/src-noconflict/mode-csound_score";
import "ace-builds/src-noconflict/mode-csp";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/mode-curly";
import "ace-builds/src-noconflict/mode-d";
import "ace-builds/src-noconflict/mode-dart";
import "ace-builds/src-noconflict/mode-diff";

import "ace-builds/src-noconflict/mode-django";
import "ace-builds/src-noconflict/mode-dockerfile";
import "ace-builds/src-noconflict/mode-dot";
import "ace-builds/src-noconflict/mode-drools";
import "ace-builds/src-noconflict/mode-edifact";
import "ace-builds/src-noconflict/mode-eiffel";
import "ace-builds/src-noconflict/mode-ejs";
import "ace-builds/src-noconflict/mode-elixir";
import "ace-builds/src-noconflict/mode-elm";
import "ace-builds/src-noconflict/mode-erlang";
import "ace-builds/src-noconflict/mode-forth";
import "ace-builds/src-noconflict/mode-fortran";
import "ace-builds/src-noconflict/mode-fsharp";
import "ace-builds/src-noconflict/mode-fsl";
import "ace-builds/src-noconflict/mode-ftl";
import "ace-builds/src-noconflict/mode-gcode";

import "ace-builds/src-noconflict/mode-gherkin";
import "ace-builds/src-noconflict/mode-gitignore";
import "ace-builds/src-noconflict/mode-glsl";
import "ace-builds/src-noconflict/mode-gobstones";
import "ace-builds/src-noconflict/mode-golang";
import "ace-builds/src-noconflict/mode-graphqlschema";
import "ace-builds/src-noconflict/mode-groovy";
import "ace-builds/src-noconflict/mode-haml";
import "ace-builds/src-noconflict/mode-handlebars";
import "ace-builds/src-noconflict/mode-haskell";
import "ace-builds/src-noconflict/mode-haskell_cabal";
import "ace-builds/src-noconflict/mode-haxe";
import "ace-builds/src-noconflict/mode-hjson";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-html_elixir";
import "ace-builds/src-noconflict/mode-html_ruby";
import "ace-builds/src-noconflict/mode-ini";
import "ace-builds/src-noconflict/mode-io";
import "ace-builds/src-noconflict/mode-ion";
import "ace-builds/src-noconflict/mode-jack";
import "ace-builds/src-noconflict/mode-jade";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/mode-json5";
import "ace-builds/src-noconflict/mode-jsoniq";
import "ace-builds/src-noconflict/mode-jsp";
import "ace-builds/src-noconflict/mode-jssm";
import "ace-builds/src-noconflict/mode-jsx";
import "ace-builds/src-noconflict/mode-julia";
import "ace-builds/src-noconflict/mode-kotlin";
import "ace-builds/src-noconflict/mode-latex";
import "ace-builds/src-noconflict/mode-latte";
import "ace-builds/src-noconflict/mode-less";
import "ace-builds/src-noconflict/mode-liquid";
import "ace-builds/src-noconflict/mode-lisp";
import "ace-builds/src-noconflict/mode-livescript";
import "ace-builds/src-noconflict/mode-logiql";
import "ace-builds/src-noconflict/mode-logtalk";
import "ace-builds/src-noconflict/mode-latte";
import "ace-builds/src-noconflict/mode-lsl";
import "ace-builds/src-noconflict/mode-lua";
import "ace-builds/src-noconflict/mode-luapage";
import "ace-builds/src-noconflict/mode-lucene";
import "ace-builds/src-noconflict/mode-makefile";
import "ace-builds/src-noconflict/mode-markdown";
import "ace-builds/src-noconflict/mode-mask";
import "ace-builds/src-noconflict/mode-matlab";
import "ace-builds/src-noconflict/mode-maze";
import "ace-builds/src-noconflict/mode-mediawiki";
import "ace-builds/src-noconflict/mode-mel";
import "ace-builds/src-noconflict/mode-mips";
import "ace-builds/src-noconflict/mode-mixal";
import "ace-builds/src-noconflict/mode-mushcode";
import "ace-builds/src-noconflict/mode-mysql";
import "ace-builds/src-noconflict/mode-nginx";
import "ace-builds/src-noconflict/mode-nim";
import "ace-builds/src-noconflict/mode-nix";

import "ace-builds/src-noconflict/mode-nsis";
import "ace-builds/src-noconflict/mode-nunjucks";
import "ace-builds/src-noconflict/mode-objectivec";
import "ace-builds/src-noconflict/mode-ocaml";
import "ace-builds/src-noconflict/mode-partiql";
import "ace-builds/src-noconflict/mode-pascal";
import "ace-builds/src-noconflict/mode-perl";
import "ace-builds/src-noconflict/mode-pgsql";
import "ace-builds/src-noconflict/mode-php";
import "ace-builds/src-noconflict/mode-php_laravel_blade";
import "ace-builds/src-noconflict/mode-pig";
import "ace-builds/src-noconflict/mode-plain_text";
import "ace-builds/src-noconflict/mode-powershell";
import "ace-builds/src-noconflict/mode-praat";
import "ace-builds/src-noconflict/mode-prisma";
import "ace-builds/src-noconflict/mode-prolog";
import "ace-builds/src-noconflict/mode-properties";
import "ace-builds/src-noconflict/mode-protobuf";
import "ace-builds/src-noconflict/mode-puppet";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-qml";
import "ace-builds/src-noconflict/mode-r";
import "ace-builds/src-noconflict/mode-raku";
import "ace-builds/src-noconflict/mode-razor";
import "ace-builds/src-noconflict/mode-rdoc";
import "ace-builds/src-noconflict/mode-red";
import "ace-builds/src-noconflict/mode-redshift";
import "ace-builds/src-noconflict/mode-rhtml";
import "ace-builds/src-noconflict/mode-robot";
import "ace-builds/src-noconflict/mode-rst";
import "ace-builds/src-noconflict/mode-ruby";
import "ace-builds/src-noconflict/mode-rust";
import "ace-builds/src-noconflict/mode-sac";
import "ace-builds/src-noconflict/mode-sass";
import "ace-builds/src-noconflict/mode-scad";
import "ace-builds/src-noconflict/mode-scala";
import "ace-builds/src-noconflict/mode-scheme";
import "ace-builds/src-noconflict/mode-scrypt";
import "ace-builds/src-noconflict/mode-scss";
import "ace-builds/src-noconflict/mode-sh";
import "ace-builds/src-noconflict/mode-sjs";
import "ace-builds/src-noconflict/mode-slim";
import "ace-builds/src-noconflict/mode-smarty";
import "ace-builds/src-noconflict/mode-smithy";
import "ace-builds/src-noconflict/mode-snippets";
import "ace-builds/src-noconflict/mode-soy_template";
import "ace-builds/src-noconflict/mode-space";
import "ace-builds/src-noconflict/mode-sparql";
import "ace-builds/src-noconflict/mode-sql";
import "ace-builds/src-noconflict/mode-sqlserver";
import "ace-builds/src-noconflict/mode-stylus";
import "ace-builds/src-noconflict/mode-svg";
import "ace-builds/src-noconflict/mode-swift";
import "ace-builds/src-noconflict/mode-tcl";
import "ace-builds/src-noconflict/mode-terraform";

import "ace-builds/src-noconflict/mode-tex";
import "ace-builds/src-noconflict/mode-text";
import "ace-builds/src-noconflict/mode-textile";
import "ace-builds/src-noconflict/mode-toml";
import "ace-builds/src-noconflict/mode-tsx";
import "ace-builds/src-noconflict/mode-turtle";
import "ace-builds/src-noconflict/mode-twig";
import "ace-builds/src-noconflict/mode-typescript";
import "ace-builds/src-noconflict/mode-vala";
import "ace-builds/src-noconflict/mode-vbscript";
import "ace-builds/src-noconflict/mode-velocity";
import "ace-builds/src-noconflict/mode-verilog";
import "ace-builds/src-noconflict/mode-vhdl";
import "ace-builds/src-noconflict/mode-visualforce";
import "ace-builds/src-noconflict/mode-wollok";
import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/mode-xquery";
import "ace-builds/src-noconflict/mode-yaml";
import "ace-builds/src-noconflict/mode-zeek";
import staticMediaSVG from '../assets/staticmedia.svg';
import { Image, ImageFit } from '@fluentui/react';
import { Spinner } from '@fluentui/react';
import * as signalR from "@microsoft/signalr";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import RatingsSection from './RatingsSection';
import { ParticipantStream } from '../core/reducers';
import { CallVideoIcon, InfoIcon } from '@fluentui/react-icons-northstar';
import CustomPopup from './CustomPopup';

export interface ChatList {
    time: string;
    message: string;
    username: string;
    userId: number;
    date_time: Date;
}[];
export interface Languages {
    Template: string;
    LanguageName: string;
    CompilerVersion: string;
    LanguageType: string;
    Alias: number;


}

export interface MediaGalleryProps {
    userId: string;
    displayName: string;
    remoteParticipants: RemoteParticipant[];
    localVideoStream: LocalVideoStream;
    dominantParticipants: SelectionState[];
    showMessages(isShowMessage: boolean, message: string): void;
    isActiveScreenShare: boolean;
    activeScreenShareStream: ParticipantStream;
}

declare global {
    var fromSetValue: boolean;
    var LanguageNameRun: string;
    var uname: string;
    var username: string;
    var userid: number;
    var qText: string;
    var uRole: string;
}

window.uname = "";
window.uRole = "";
window.qText = "";

connection;
//let fromSetValue = true;
window.fromSetValue = true;


//const connection = new signalR.HubConnectionBuilder()
//    .withUrl("/hub", {
//        skipNegotiation: true,
//        transport: signalR.HttpTransportType.WebSockets
//    })
//    .build();

//connection.on("sendGroupMsg", (message: string, username: string, userid: number, type: string) => {

//    console.log("CG :: " + uname);
//    if (username != uname) {
//        if (fromSetValue) {
//            fromSetValue = false;
//        }

//        if (type == "chat") {
//            if (message != "") {
//                const tbMessage: HTMLInputElement | null = document.querySelector("#tbMessage");
//                const divMessages: HTMLDivElement | null = document.querySelector("#divMessages");
//                const m = document.createElement("div");
//                let time = "";
//                time = new Date().getHours() + ":" + new Date().getMinutes();
//                let Datetime = new Date();
//                Datetime = new Date();
//                //chatL.push({ time: time, message: message, username: username, userId: userid, date_time: Datetime });
//                Addchatlist(time, message, username, userid, Datetime);
//                m.innerHTML = `<div class="message-author">${username}<span style="font-weight: 100;">${" " + time}</span></div><div class="ChatDiv">${message}</div>`;

//                if (tbMessage != null && divMessages != null) { 
//                tbMessage.value = ""
//                divMessages.appendChild(m);
//                divMessages.scrollTop = divMessages.scrollHeight;
//            }
//            }
//        }
//        else if (type == "drp") {
//            const items = localStorage.getItem(message);
//            (document.getElementById("lstLanguages_ListOfLanguages") as HTMLInputElement).value = message;

//            LanguageNameRun = message;
//            if (message == 'c') {
//                message = 'c_cpp';
//            } else if (message == 'c#') {
//                message = 'csharp';
//            } else if (message == 'c#') {
//                message = 'csharp';
//            }
//            else if (message == 'python3') {
//                message = 'python';
//            }
//            else if (message == 'pas fpc') {
//                message = 'pascal';
//            }

//            let ace: any = "";
//                ace = require('ace-builds/src-noconflict/ace');
//            let editor: any = "";
//            editor = ace.edit('editor');
//            editor.getSession().setUseWorker(false);
//            editor.setShowPrintMargin(false);
//            editor.setReadOnly(false);
//            editor.setValue(items);
//            editor.gotoLine(1, 0);
//            editor.getSession().setMode('ace/mode/' + message);
//            editor.session.setMode("ace/mode/" + message);
//        }
//        else if (type == "code" || type == "CInput" || type == "Input" || type == "Output") {
//            let ace: any = "";
//            ace = require('ace-builds/src-noconflict/ace');
//            let editorId = "";

//            if (type == "CInput") {
//                editorId = 'CInputeditorsection';
//            }
//            if (type == "Input") {
//                editorId = 'Inputeditor';
//            }
//            if (type == "Output") {
//                editorId = 'Outputeditor';
//            }
//            if (type == "code") {
//                editorId = 'editor';
//            }

//            let editor :any = "";
//            editor = ace.edit(editorId);

//            editor.setValue(message);

//        }
//        else if (type == "ps") {
//            (document.getElementById("questiontext") as HTMLInputElement).value = message;
//        }

//    }
//    else {
//        fromSetValue = true;
//    }
//});

//connection.start().catch((err) => document.write(err));



export async function Run(candtestid: number) {
    // try {
    //  const [data, setData] = useState([]);
    let ace: any = "";
    ace = require('ace-builds/src-noconflict/ace');
    let editor: any = "";
    editor = ace.edit('editor');
    let editor2: any = "";
    editor2 = ace.edit('CInputeditorsection');
    let editor3: any = "";
    editor3 = ace.edit('Inputeditor');

    let setBody = "";
    setBody = JSON.stringify({
        CandTestId: candtestid,
        TimeTaken: 0,
        QuestionId: 0,
        LanguageName: window.LanguageNameRun,
        Code: encodeURIComponent(editor.getValue()),
        IsSubmit: 0,
        Input: encodeURIComponent(editor3.getValue()), // consoleInput
        cmdLine: editor2.getValue(),// command line Input

    })
    const getData =
        await fetch(window.coAPI + "Run", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: setBody

        }).then(function (response) {
            console.log(response)
            return response.json();
        })
            .then(function (myJson) {
                console.log(myJson); // output
                rurData = myJson as RunReponse;
                //rurData =  ;
            });


    await getData;

    console.log('response.json()');
    let languages = rurData;
    languages = rurData;
    return languages;
}
window.LanguageNameRun = "Java";
getAllLanguages();

type One = {
    Alias: string,
    CompilerVersion: string,
    LanguageName: string,
    LanguageType: string,
    Template: string,
    isCmdLineOn: number
}[];

type RunReponse = {
    testCases: string,
    testCaseCount: string,
    output: string,
    statusCode: string
}
const imageProps = {
    src: staticMediaSVG.toString(),
    imageFit: ImageFit.contain,
    styles: {
        root: {
            width: '100%',
            height: '100%',

        }
    }
};

const dropDownOptions = [
    { value: "Interviewer", text: "Interviewer" },
    { value: "Candidate", text: "Candidate" }
];

let rurData: RunReponse;
let data2: One;
async function getAllLanguages() {
    // try {
    //  const [data, setData] = useState([]);
    let data;
    //alert(window.coAPI);
    const getData = await fetch("https://cgapi.cogbee.io:8082/Languages", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },

    }).then(function (response) {
        //   console.log(response)
        return response.json();
    })
        .then(function (myJson) {

            //   console.log(myJson);

            data2 = myJson as One;


        });

    // }

    await getData;
    //   console.log('response.json()');

    return data;
    //return { data: { comments: [] } };

}
//let username = "";
//let userid = 1;
window.username = "";
window.userid = 1;
//function send(message: string, type: string) {

//    if (type == "chat") {
//        if (message != "") {
//            const tbMessage: HTMLInputElement | null = document.querySelector("#tbMessage");
//            const divMessages: HTMLDivElement | null = document.querySelector("#divMessages");
//            const m = document.createElement("div");
//            m.style.textAlign = "right";
//            let time = "";
//            time = new Date().getHours() + ":" + new Date().getMinutes();
//            let DateTime = new Date();
//            DateTime = new Date();
//            //var chatL[];
//            //let chatL = [];
//            //chatL.push({ time: time, message: message, username: username.toString(), userId: userid, date_time: DateTime });
//            Addchatlist(time, message, username, userid, DateTime);
//            m.innerHTML = `<div class="message-author">${username}<span style="font-weight: 100;">${" " + time}</span></div><div class="ChatDiv" style="margin-left: auto;">${message}</div>`;
//            if (tbMessage != null && divMessages != null) {
//                tbMessage.value = ""
//                divMessages.appendChild(m);
//                divMessages.scrollTop = divMessages.scrollHeight;
//            }
//        }
//    }
//    //connection.send("RemoveFromGroup", uriGid);
//    MessageGroup(uriGid, username, userid, message, type);

//}

function SetEditor(from: string, id: string) {
    if (window.fromSetValue) {

        let ace: any = "";
        ace = require('ace-builds/src-noconflict/ace');
        let editor: any = "";
        editor = ace.edit(id);

        let val: any = "";
        val = editor.getValue();

        console.log("tbMessageGroup.value::" + "A");

        send(val, from, true);

        //  connection.send("addToGroup", uriGid, val, uname);
    }
    else {
        window.fromSetValue = true;
    }



}


//function SetInput(from: string, id: string,Candidate:boolean) {


//        if (window.fromSetValue) {


//            let val = "";
//            val = (document.getElementById(id) as HTMLInputElement).value

//            //  console.log("SetInput::" + "A");

//            send(val, from, Candidate);
//        }
//        else {
//            window.fromSetValue = true;
//        }



//}


export default (props: MediaGalleryProps): JSX.Element => {
    const rendererViewRef = useRef<VideoStreamRendererView>();
    const [loading, setLoading] = useState(true);
    const activeScreenShareStream = props.activeScreenShareStream;

    const renderStreamCallback = useCallback(async () => {
        if (activeScreenShareStream && activeScreenShareStream.stream) {
            const stream: RemoteVideoStream = activeScreenShareStream.stream;
            const renderer: VideoStreamRenderer = new VideoStreamRenderer(stream);
            rendererViewRef.current = await renderer.createView({ scalingMode: 'Fit' });

            //const container = document.getElementById(fullScreenStreamMediaId);
            const container = document.getElementById("tabScreenshare");
            if (container && container.childElementCount === 0) {
                setLoading(false);
                container.appendChild(rendererViewRef.current.target);
            }
        } else {
            if (rendererViewRef) {
                rendererViewRef.current?.dispose();
            }
        }
    }, [activeScreenShareStream]);

    useEffect(() => {
        renderStreamCallback();
    }, [renderStreamCallback]);

    const [gridCol, setGridCol] = useState(1);
    const [gridRow, setGridRow] = useState(1);

    window.username = (props.displayName).split("_")[0];


    const modelone: ParticipantInfo = ParticipantModel();
    let isInterviewer = false;
    let isMobile = false;
    isMobile = modelone.isMobile == 'true' ? true : false;
    window.uRole = modelone.role;
    if (modelone.role == "Interviewer" || modelone.role == "Spoc") {
        isInterviewer = true;
    }
    else {
        isInterviewer = false;
    }

    window.userid = modelone.userId;
    // For now we are only going to support up to a 4x4 grid or 16 people in a call
    // Since this is a sample, we will just hard-code how we want the grid to scale
    // the rows and columns for the number of users in the call
    // total participants  1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16
    const rows = [1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4];
    const cols = [1, 2, 2, 2, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4];

    if (Constants.DOMINANT_PARTICIPANTS_COUNT < 0 || Constants.DOMINANT_PARTICIPANTS_COUNT > rows.length) {
        console.warn(`Please use a value for dominant participants between 0 < x < ${rows.length}`);
    }

    const numRemoteParticipantsToRender = Math.min(Constants.DOMINANT_PARTICIPANTS_COUNT, rows.length - 1);

    const clamp = (num: number, min: number, max: number) => Math.min(Math.max(num, min), max);


    //debugger;


    if (props.remoteParticipants.length <= 0 && modelone.role != "Interviewer") {

        /*if (!props.showMessage)*/

        //props.showMessages(true,"Please wait for interviewer to join this interview.");

        window.cogbeeMessage = "Please wait for interviewer to join this interview.";
        window.showMessage = true;


        /*props.showMessage = true;*/
    }

    window.addEventListener('beforeunload', function (e) {
        LeaveInterviewCall();
    });

    const App1 = () => {

        if (!connection) {
            connection;
        }

        connection.send("AddToGroup", uriGid);

        if (modelone.role != "Interviewer" && props.remoteParticipants.length <= 0) {

            connection.send("MessageGroup", uriGid, window.username, modelone.userId, "", "cActive", true);
        }

        const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
            let value = event.target.value.toLowerCase();
            const items = localStorage.getItem(value);
            LanguageNameRun = value;
            send(value, "drp", true);

            if (value == 'c') {
                value = 'c_cpp';
            } else if (value == 'c#') {
                value = 'csharp';
            } else if (value == 'c#') {
                value = 'csharp';
            }
            else if (value == 'python3') {
                value = 'python';
            }
            else if (value == 'pas fpc') {
                value = 'pascal';
            }
            //var navigator1 = window.navigator;
            //var browserN = "";
            //var versionN = "";
            //if (navigator1.webkitGetUserMedia || window.isSecureContext === false && window.webkitRTCPeerConnection && !window.RTCIceGatherer) {
            //    browserN = 'chrome';
            //    versionN = extractVersion(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
            //} else if (navigator1.mediaDevices && navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
            //    browserN = 'edge';
            //    versionN = extractVersion(navigator.userAgent, /Edge\/(\d+).(\d+)$/, 2);
            //} else if (window.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
            //    browserN = 'safari';
            //    versionN = extractVersion(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
            //} else {
            //    browserN = 'Not a supported browser.';
            //}
            //alert(''
            //    + 'osName  = ' + browserN + ','
            //    + 'osVersion  = ' + versionN + ','
            //    + 'appVersion = ' + navigator.userAgent + ''
            //)


            //alert(browserN + "," + versionN);
            let ace: any = "";
            ace = require('ace-builds/src-noconflict/ace');

            let editor: any = "";
            editor = ace.edit('editor');
            editor.getSession().setUseWorker(false);
            editor.setShowPrintMargin(false);
            editor.setReadOnly(false);
            editor.setValue(items);
            editor.gotoLine(1, 0);
            editor.getSession().setMode('ace/mode/' + value);
            editor.session.setMode("ace/mode/" + value);

            let editor2: any = "";
            editor2 = ace.edit('CInputeditorsection');
            editor2.gotoLine(1, 0);
            editor2.getSession().setMode('ace/mode/' + value);
            editor2.session.setMode("ace/mode/" + value);

            let editor3: any = "";
            editor3 = ace.edit('Inputeditor');
            editor3.gotoLine(1, 0);
            editor3.getSession().setMode('ace/mode/' + value);
            editor3.session.setMode("ace/mode/" + value);

            let editor4: any = "";
            editor4 = ace.edit('Outputeditor');
            editor4.gotoLine(1, 0);
            editor4.getSession().setMode('ace/mode/' + value);
            editor4.session.setMode("ace/mode/" + value);

        };


        let GetOptions = [];
        GetOptions = [];
        localStorage.clear();
        if (data2 != undefined && data2 != null) {
            for (let j = 0; j < data2.length; j++) {
                localStorage.setItem(data2[j].LanguageName, decodeURIComponent(data2[j].Template));
                GetOptions.push(<option key={data2[j].LanguageName} value={data2[j].LanguageName}>
                    {data2[j].LanguageName}
                </option>);
            }
        }

        const [style, setStyle] = useState("CInput");
        const [style1, setStyle1] = useState("Input");
        const [style2, setStyle2] = useState("Output");

        const [styleEditor, setStyleEditor] = useState("CInputEditor");
        const [style1Editor, setStyle1Editor] = useState("InputEditor1");
        const [style2Editor, setStyle2Editor] = useState("OutputEditor1");

        const [tabCodingDeckStyle, tabCodingDeckShow] = useState("ShowtabCoding");
        const [tabVideoStyle, tabVideoDeckShow] = useState("ShowtabVideo1");
        const [tabResumeStyle, setResumeDivStyle] = useState("ShowtabVideo1");
        const [tabRatingStyle, setRatingDivStyle] = useState("ShowtabVideo1");
        const [tabScreenshare, setScreenshareDivStyle] = useState("ShowScreenshare1");

        const [Screenshare, ScreenshareShow] = useState("Screenshare");
        const [CodingDeck, CodingDeckShow] = useState("Coding-Deck");
        const [ResumeTabS, setResumeTabStyle] = useState("Screenshare");
        const [RatingTabS, setRatingTabStyle] = useState("Screenshare");


        const [isShown, setIsShown] = useState(false);

        const ShowCoding = () => {
            tabCodingDeckShow("ShowtabCoding");
            tabVideoDeckShow("ShowtabVideo1");
            ScreenshareShow('Screenshare');
            CodingDeckShow('Coding-Deck');
            setResumeTabStyle('Screenshare');
            setRatingTabStyle('Screenshare');
            setResumeDivStyle('ShowtabResume1');
            setRatingDivStyle('ShowtabRating1');
            setScreenshareDivStyle('ShowScreenshare1');
        }
        const ShowVideo = () => {
            ScreenshareShow('Coding-Deck');
            CodingDeckShow('Screenshare');
            tabCodingDeckShow("ShowtabCoding1");
            tabVideoDeckShow("ShowtabVideo");
            setResumeTabStyle('Screenshare');
            setRatingTabStyle('Screenshare');
            setResumeDivStyle('ShowtabResume1');
            setRatingDivStyle('ShowtabRating1');
            setScreenshareDivStyle('ShowScreenshare1');
        }

        const ShowResume = () => {
            setResumeDivStyle('ShowtabResume');
            setResumeTabStyle('Coding-Deck');
            setRatingTabStyle('Screenshare');

            ScreenshareShow('Screenshare');
            CodingDeckShow('Screenshare');
            ScreenshareShow('Screenshare');
            tabCodingDeckShow("ShowtabCoding1");
            tabVideoDeckShow("ShowtabVideo1");
            setRatingDivStyle('ShowtabRating1');
            setScreenshareDivStyle('ShowScreenshare1');
        }

        const ShowRating = () => {
            setRatingDivStyle('ShowtabRating');
            setResumeDivStyle('ShowtabResume1');
            setRatingTabStyle('Coding-Deck');
            setResumeTabStyle('Screenshare');

            CodingDeckShow('Screenshare');
            ScreenshareShow('Screenshare');
            tabCodingDeckShow("ShowtabCoding1");
            tabVideoDeckShow("ShowtabVideo1");
            setScreenshareDivStyle('ShowScreenshare1');
        }

        const ShowScreenshare = () => {
            setRatingDivStyle('ShowtabRating1');
            setResumeDivStyle('ShowtabResume1');
            setRatingTabStyle('Screenshare');
            setResumeTabStyle('Screenshare');
            ScreenshareShow('Coding-Deck');

            CodingDeckShow('Screenshare');
            tabCodingDeckShow("ShowtabCoding1");
            tabVideoDeckShow("ShowtabVideo1");
            setScreenshareDivStyle('ShowScreenshare');
        }

        const changeStyle = () => {
            setStyle("CInput");
            setStyle1("Input");
            setStyle2("Output");
            setStyleEditor("CInputEditor");
            setStyle1Editor("InputEditor1");
            setStyle2Editor("OutputEditor1");
        };
        const changeStyle1 = () => {
            setStyle("CInput1");
            setStyle1("Input1");
            setStyle2("Output");
            setStyleEditor("CInputEditor1");
            setStyle1Editor("InputEditor");
            setStyle2Editor("OutputEditor1");
        };
        const changeStyle2 = () => {
            setStyle("CInput1");
            setStyle1("Input");
            setStyle2("Output1");

            setStyleEditor("CInputEditor1");
            setStyle1Editor("InputEditor1");
            setStyle2Editor("OutputEditor");
        };

        useEffect(() => {
            if (props.isActiveScreenShare) {
                ShowScreenshare();
            }
            else {
                ShowCoding();
            }
        }, [props.isActiveScreenShare]);



        const runclick = () => {
            let divSpinner: HTMLDivElement | null;
            divSpinner = null;
            divSpinner = document.querySelector("#divSpinner");

            if (divSpinner != null) {
                (async () => {
                    divSpinner.style.display = "inline-grid";
                    await Run(modelone.candidateTestId);
                })().then(function () {

                    let ace: any = "";
                    ace = require('ace-builds/src-noconflict/ace');
                    let editor4: any = "";
                    editor4 = ace.edit('Outputeditor');
                    editor4.renderer.setShowGutter(false);
                    editor4.setValue(rurData.output);
                    editor4.setOptions({ readOnly: true, highlightActiveLine: true });



                    setStyle("CInput1");
                    setStyle1("Input");
                    setStyle2("Output1");

                    setStyleEditor("CInputEditor1");
                    setStyle1Editor("InputEditor1");
                    setStyle2Editor("OutputEditor");

                    //send("", "Run");
                    //SetInput("ps", "questiontext")
                    SetEditor("Output", "Outputeditor");
                    if (divSpinner != null) {
                        divSpinner.style.display = "none";
                    }
                });
            }
        };
        //var ace = require('ace-builds/src-noconflict/ace');
        //var editor = ace.edit("editor");                   // the editor object
        //var editorDiv = document.getElementById("editor");     // its container
        ////var doc = editor.getSession().getDocument();  // a reference to the doc
        //if (editor) {
        //    editor.on("change", function () {
        //        editorDiv.style.height = "350px";
        //        editor.resize();
        //    });
        //}
        const [isToolTipShow, setToolTipShow] = useState(false);
        const togglePopupClose = (isShow: boolean) => {
            setToolTipShow(isShow);
        }

        useEffect(() => {
            popupBodyContent
        }, [modelone]);

        const popupBodyContent = () => {
            return (
                <div className="tooltipMailDiv">
                    <table id="Interpretation" width="100%">
                        <tr>
                            <th>Weight</th>
                            <th>Interpretation</th>
                        </tr>
                        {
                            App1()
                        }
                    </table>
                </div>
            );
        }

        const App1 = () => {
            if (modelone != undefined && modelone.interpretationList != undefined) {
                const nterpretationList = modelone.interpretationList as Interpretation[];
                const App2 = nterpretationList.map((nterpretation) => (
                    <tr key={nterpretation.iWeight}>
                        <td>{nterpretation.iWeight}</td>
                        <td>{nterpretation.interpretationText}</td>
                    </tr>
                ));
                return App2;
            } else {
                const App2 = () => (<div></div>);
                return App2;
            }
        }

        if (modelone.isMobile == "true") {

            return (<div> </div>);

        }
        else {

            return (
                <div>
                    <div
                        className={CodingDeck}
                        id="dvCD"
                        onClick={ShowCoding}
                    >
                        Coding Deck
                    </div>
                    <div
                        //className={Screenshare}
                        //id="dvZV"
                        //onClick={ShowVideo}
                        style={{ display: 'none' }}
                    >
                        Video
                    </div>

                    {isInterviewer && modelone.role != "Spoc" ? (
                        <>
                            <div
                                className={ResumeTabS}
                                id="dvRS"

                                style={{ display: "" }}
                                onClick={ShowResume}
                            >
                                Resume
                            </div>
                            <div
                                className={RatingTabS}
                                id="dvRateS"
                                style={{ display: "" }}
                                onClick={ShowRating}
                            >
                                Rating
                                <InfoIcon onMouseEnter={() => { togglePopupClose(true); }} style={{ marginBottom: "10px", marginLeft: "5px" }} />

                            </div>

                            {isToolTipShow && (
                                <CustomPopup
                                    BodyContent={popupBodyContent}
                                    btnCancel=""
                                    btnConfirm=""
                                    lblTitle="Interpretation"
                                    ConfirmHandler={popupBodyContent}
                                    togglePopupClose={() => { togglePopupClose(false); }}
                                    popupHeight="350px"
                                    isShowCloseButton="true"
                                />)
                            }

                        </>

                    ) : (<div style={{ display: "none" }}></div>)}
                    {props.isActiveScreenShare && (
                        <div
                            className={Screenshare}
                            id="dvScreenshare"

                            style={{ display: "" }}
                            onClick={ShowScreenshare}
                        >
                            Screenshare
                        </div>
                    )}
                    {/* style={{ display: isShown ? 'block' : 'none' }*/}
                    <div id="tabCodingDeck" className={tabCodingDeckStyle}>
                        <div>
                            <select
                                className="dropdown DropDownClass"
                                id="lstLanguages_ListOfLanguages"
                                name="lstLanguages.ListOfLanguages"
                                onChange={selectChange}
                                style={{
                                    background: "white",
                                    fontSize: 14,
                                    margin: "6px 0px",
                                    borderRadius: 6,
                                    border: "solid 1px #cbd5e0",
                                    backgroundColor: "#ffffff"
                                }}
                                tabIndex={1}
                            >

                                <option value="">Select</option>
                                {GetOptions}
                            </select>
                            <div id="divSpinner" style={{ display: "none", float: "right", paddingTop: "13px" }}>
                                <Spinner label="" ariaLive="assertive" labelPosition="top" style={{ display: "inline-grid" }} />
                            </div>
                            <button
                                type="button"
                                id="sbutton"

                                style={{
                                    float: "right",
                                    marginTop: 10,
                                    marginRight: '5px',
                                    borderRadius: 6,
                                    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                                    backgroundColor: "#0c44ac",
                                    fontWeight: 500
                                }}
                                className="btn btn-light tabButtonOp"

                                onClick={runclick}
                            >
                                Run
                            </button>
                            {/*{selectedOption && <h2>{selectedOption}</h2>}*/}
                        </div>
                        <div
                            style={{ paddingLeft: 0 }}
                        >

                            <div>
                                {/*{isInterviewer ? (*/}
                                {/*    <AceEditor*/}
                                {/*        mode="csharp"*/}
                                {/*        theme="github"*/}
                                {/*        name="editor"*/}
                                {/*        editorProps={{*/}
                                {/*            $blockScrolling: true*/}
                                {/*        }}*/}
                                {/*        style={{ height: isInterviewer ? "200px" :"300px" }}*/}
                                {/*        onInput={(event) => SetEditor("code", "editor")}*/}
                                {/*    />*/}
                                {/*) : (*/}
                                {/*        <AceEditor*/}
                                {/*            mode="csharp"*/}
                                {/*            theme="github"*/}
                                {/*            name="editor"*/}
                                {/*            editorProps={{*/}
                                {/*                $blockScrolling: true*/}
                                {/*            }}*/}
                                {/*            style={{ height: "350px" }}*/}
                                {/*            onInput={(event) => SetEditor("code", "editor")}*/}
                                {/*        />*/}
                                {/*        )}*/}
                                <AceEditor
                                    mode="csharp"
                                    theme="github"
                                    name="editor"
                                    editorProps={{
                                        $blockScrolling: true
                                    }}
                                    style={{ height: isInterviewer ? "200px" : "300px" }}
                                    onInput={(event) => SetEditor("code", "editor")}
                                />
                            </div>

                            <div style={{ padding: "5px 0px 5px 5px", fontSize: "13px" }}>
                                <div className={style}
                                    id="dvCInput"
                                    onClick={changeStyle}
                                >
                                    <div style={{ lineHeight: "2.3em" }} >
                                        Command line Input
                                    </div>
                                </div>
                                <div
                                    id="dvInput"
                                    className={style1}
                                    style={{ borderRadius: 0, marginLeft: "-4px" }}
                                    onClick={changeStyle1}
                                >
                                    <div style={{ lineHeight: "2.3em" }}>Console Input</div>
                                </div>
                                <div id="dvOutput" className={style2} onClick={changeStyle2}>
                                    <div style={{ lineHeight: "2.3em" }}>
                                        Output
                                    </div>
                                </div>
                            </div>
                            <div className={styleEditor} style={{}}>
                                <div>
                                    <AceEditor
                                        theme="github"
                                        name="CInputeditorsection"
                                        editorProps={{
                                            $blockScrolling: true
                                        }}
                                        onInput={(event) => SetEditor("CInput", "CInputeditorsection")}

                                    />
                                </div>
                            </div>
                            <div className={style1Editor} style={{}}>
                                <div>
                                    <AceEditor
                                        theme="github"
                                        name="Inputeditor"
                                        editorProps={{
                                            $blockScrolling: true
                                        }}
                                        onInput={(event) => SetEditor("Input", "Inputeditor")}
                                    />
                                </div>
                            </div>
                            <div className={style2Editor} style={{}}>
                                <div>
                                    <AceEditor
                                        theme="github"
                                        name="Outputeditor"
                                        editorProps={{
                                            $blockScrolling: true
                                        }}
                                        onInput={(event) => SetEditor("Output", "Outputeditor")}
                                    />
                                </div>
                            </div>
                            <div
                                style={{
                                    width: "98.5%",
                                    height: 1,
                                    border: "solid 1px #e2e8f0",
                                    marginLeft: 5,
                                    marginTop: 10
                                }}
                            />
                            {isInterviewer && modelone.role != "Spoc" ? (
                                <div>
                                    <div
                                        style={{
                                            width: 127,
                                            height: 20,
                                            borderRadius: 6,
                                            backgroundColor: "#ebf8ff",
                                            color: "#2b6cb0",
                                            paddingLeft: 5,
                                            marginTop: 10,
                                            marginLeft: 5
                                        }}
                                    >
                                        {" "}
                                        Problem Statement{" "}
                                    </div>

                                    <div className="panel-body customPanelBody" style={{}}>
                                        <div className="container-fluid" style={{ paddingLeft: 5 }}>
                                            <h5>
                                                <textarea

                                                    className="form-control clstext"
                                                    id="questiontext"
                                                    rows={11}
                                                    style={{
                                                        height: 100,
                                                        fontSize: 13,
                                                        width: "96%",
                                                        border: "1px solid #e2e8f0",
                                                        boxSizing: "unset",
                                                        marginTop: 10,
                                                        color: "black"
                                                    }}
                                                    defaultValue={""}
                                                    onKeyUp={(event) => { SetInput("ps", "questiontext", true) }}

                                                />
                                            </h5>
                                        </div>
                                    </div>

                                </div>
                            ) : ""}
                        </div>
                    </div>
                    <div id="dvNJ" className="dvWait d-none" style={{ display: 'none' }}>
                        Waiting for others to join...
                    </div>
                    <div id="tabZoomView" className={tabVideoStyle}>
                        <div style={{
                            width: '100%',
                            height: '100%'
                        }}>
                            <div className="css-72" id="imgnew" style={{ display: "none" }}>
                                <Image {...imageProps} style={{
                                    width: '35%',
                                    height: '48%',
                                    objectFit: 'cover',
                                    position: 'inherit',
                                    marginTop: '23%',
                                }} />
                            </div>
                            <video
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    paddingBottom: '10px'
                                }}

                                id="vdonew"
                            >


                            </video>
                        </div>
                    </div>
                    <div id="resumeView" className={tabResumeStyle}>
                        <div style={{
                            width: '100%',
                            height: '100%'
                        }}>
                            {modelone.htmlResumeURL ? (
                                <div className="css-72" id="resumeIframe" style={{ width: '100%' }}>
                                    <iframe src={modelone.htmlResumeURL} height="500" width="100%" />
                                </div>) : (
                                <>
                                    <div className="dvWait">
                                        No Resume Found
                                    </div>

                                </>
                            )
                            }
                            {/*    {modelone.HTMLResumeURL?(
                        {/*    <div className="css-72" id="resumeIframe" style={{ display: "none" }}>*/}
                            {/*        <iframe src="https://dev.cogbee.io//Document/1/Candidate/Resume/R_20231920111902.pdf" height="500" width="500" />*/}
                            {/*        </div>) : (<div className="dvWait d-none">*/}
                            {/*           No Resume Found*/}
                            {/*        </div>)*/}
                            {/*}*/}

                        </div>
                    </div>

                    {/*Rating Section Start*/}
                    <div id="tabRatingSection" className={tabRatingStyle}>
                        <RatingsSection />
                    </div>
                    {/*Rating Section End*/}

                    {/*Screenshare Section Start*/}
                    <div id="tabScreenshare" className={tabScreenshare}>
                    </div>
                    {/*Screenshare Section End*/}
                </div>
            );
        }
    };


    const AppRSignal = () => {
        connection.send("AddToGroup", uriGid);

        if (modelone.role != "Interviewer" && props.remoteParticipants.length <= 0) {

            connection.send("MessageGroup", uriGid, window.username, modelone.userId, "", "cActive", true);
        }

        return (<div> </div>);
    };

    const getMediaGalleryTilesForParticipants = (
        participants: RemoteParticipant[],
        displayName: string
    ): JSX.Element[] => {

        window.uname = displayName.split("_")[0];

        const remoteParticipantsMediaGalleryItems = participants.map((participant) => (

            <div key={`${utils.getId(participant.identifier)}-tile`} className={mediaGalleryStyle} style={{
                height: '100%'
            }}>
                <RemoteStreamMedia
                    key={utils.getId(participant.identifier)}
                    stream={participant.videoStreams[0]}
                    isParticipantStreamSelected={
                        props.dominantParticipants.filter((p) => p.participantId === utils.getId(participant.identifier)).length > 0
                    }
                    label={participant.displayName ?? utils.getId(participant.identifier)}
                    isMutes={
                        props.remoteParticipants.filter((p) => p.identifier === participant.identifier).length > 0 ?
                            props.remoteParticipants.filter((p) => p.identifier === participant.identifier)[0].isMuted:false
                    }
                    isMobile={isMobile}
                />
            </div>

        ));

        // for now we will always add the local user to the main stage
        const localParticipantMediaGalleryItem = (
            <div key="localParticipantTile" className={mediaGalleryStyle}>
                <LocalStreamMedia label={displayName.split("_")[0]} stream={props.localVideoStream} />
            </div>
        );

        remoteParticipantsMediaGalleryItems.unshift(localParticipantMediaGalleryItem);

        return remoteParticipantsMediaGalleryItems;
    };

    const getSubstageMediaGalleryTilesForParticipants = (participants: RemoteParticipant[]): JSX.Element[] => {
        const remoteParticipantsMediaGalleryItems = participants.map((participant) => (
            <div key={`${utils.getId(participant.identifier)}-tile`} className={substageMediaGalleryStyle}>
                <RemoteStreamMedia
                    key={utils.getId(participant.identifier)}
                    stream={participant.videoStreams[0]}
                    isParticipantStreamSelected={false}
                    label={participant.displayName ?? utils.getId(participant.identifier)}
                    isMutes={
                        props.remoteParticipants.filter((p) => p.identifier === participant.identifier).length > 0 ?
                            props.remoteParticipants.filter((p) => p.identifier === participant.identifier)[0].isMuted : false
                    }
                    isMobile={isMobile}
                />
            </div>
        ));

        return remoteParticipantsMediaGalleryItems;
    };

    // determine number of rows/columns to add to the grid
    const numberStreamsToRender = useMemo(
        () => clamp(props.remoteParticipants.length, 0, numRemoteParticipantsToRender),
        [props.remoteParticipants.length]
    );
    if (cols[numberStreamsToRender] !== gridCol) {
        if (numberStreamsToRender > cols.length - 1) {
            throw `attempting to set up a number of columns in the gallery for an unexpected number of participants ${numberStreamsToRender}`;
        }
        setGridCol(cols[numberStreamsToRender]);
    }

    if (rows[numberStreamsToRender] !== gridRow) {
        if (numberStreamsToRender > rows.length - 1) {
            throw `attempting to set up a number of rows in the gallery for an expected unnumber of participants ${numberStreamsToRender}`;
        }
        setGridRow(rows[numberStreamsToRender]);
    }

    // sort by dominance
    const participantsToLayout = props.remoteParticipants.sort((a, b) => {
        const isParticipantADominant =
            props.dominantParticipants.filter((p) => p.participantId === utils.getId(a.identifier)).length > 0;
        const isParticipantBDominant =
            props.dominantParticipants.filter((p) => p.participantId === utils.getId(b.identifier)).length > 0;
        if (isParticipantADominant && !isParticipantBDominant) {
            return -1;
        } else if (!isParticipantADominant && isParticipantBDominant) {
            return 1;
        }
        return 0;
    });
    const mainStageParticipants = participantsToLayout.slice(0, numRemoteParticipantsToRender);
    const gridPemplateRows = mainStageParticipants.length + 1;
    console.log("COGBEE :: mainStageParticipants");
    // console.log(mainStageParticipants);

    const substageParticipants = participantsToLayout.slice(numRemoteParticipantsToRender);
    // don't show the substage if its not necessary
    const isSubstageVisible = substageParticipants.length > 0;

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    const options = ['Candidate', 'Interviewer'];

    const handleClick = () => {
        let IsCandidate = true;
        if ((modelone.role == "Interviewer" || modelone.role == "Spoc") && options[selectedIndex] === "Interviewer") {
            IsCandidate = false;
        }

        SetInput("chat", "tbMessage", IsCandidate);
        chatAdd(uriCode);
    };

    const handleMenuItemClick = (event: React.MouseEvent, index: number) => {
        setSelectedIndex(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        if (anchorRef.current) {
            return;
        }

        setOpen(false);
    };

    // Create interface for load chat data for view
    interface ChatDataModel {
        userId: number,
        date_Time: Date,
        username: string,
        time: string,
        message: string,
        isShowAll: false
    }

    // Store chart data in getChatData object
    const getChatData = GetChatList() as ChatDataModel[];

    // Scroll Page Reference and scroll down/bottom
    //const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        const divMessages: HTMLDivElement | null = document.querySelector("#divMessages");
        if (divMessages != null)
            divMessages.scrollTop = divMessages.scrollHeight;
    }

    useEffect(() => {
        scrollToBottom();
        AppRSignal();
    }, []);

    return (

        <Stack style={{ height: '100%' }}>
            <main role="main" className="container-fluid d-none" style={{ width: '100%', background: 'rgb(250, 249, 248)' }} >
                {/*<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">*/}
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-2" id="div1" style={{
                            height: '620px',
                            padding: '0px !important'
                        }} >
                            <div
                                id="video-gallery"
                                className={mediaGalleryGridStyle}
                                style={{
                                    gridTemplateRows: `repeat(${isMobile ? gridPemplateRows : 4}, minmax(0, 1fr))`,
                                    gridTemplateColumns: `repeat(${1}, 1fr)`,
                                    overflow: 'auto'
                                }}
                            >

                                {getMediaGalleryTilesForParticipants(mainStageParticipants, props.displayName)}
                            </div>
                        </div>
                        {!isMobile ? (
                            <div className="col-md-7" id="divCode" style={{
                                borderLeftColor: 'rgb(217, 217, 217)',
                                borderLeftStyle: 'solid',
                                borderLeftWidth: '1px',
                                borderLeft: '0px',
                                //padding: '15px',
                                paddingTop: '0px'
                            }} >
                                <div
                                    id="div2"
                                    style={{
                                        borderRadius: 6,
                                        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "#ffffff",
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        height: '100%'
                                    }}
                                    className="mCustomScrollbar _mCS_3 mCS_no_scrollbar"
                                >
                                    <div
                                        id="mCSB_3"
                                        className="mCustomScrollBox mCS-dark mCSB_vertical mCSB_inside"
                                        style={{ maxHeight: "none" }}
                                        tabIndex={0}
                                    >
                                        <div
                                            id="mCSB_3_container"
                                            className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
                                            style={{ position: "relative", top: 0, left: 0 }}
                                            dir="ltr"
                                        >
                                            {App1()}

                                        </div>
                                        <div
                                            id="mCSB_3_scrollbar_vertical"
                                            className="mCSB_scrollTools mCSB_3_scrollbar mCS-dark mCSB_scrollTools_vertical"
                                            style={{ display: "none" }}
                                        >
                                            <a href="#" className="mCSB_buttonUp" />
                                            <div className="mCSB_draggerContainer">
                                                <div
                                                    id="mCSB_3_dragger_vertical"
                                                    className="mCSB_dragger"
                                                    style={{ position: "absolute", minHeight: 30, top: 0, height: 0 }}
                                                >
                                                    <div className="mCSB_dragger_bar" style={{ lineHeight: 30 }} />
                                                </div>
                                                <div className="mCSB_draggerRail" />
                                            </div>
                                            <a href="#" className="mCSB_buttonDown" />
                                        </div>
                                    </div>
                                </div>
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        ) : (<div style={{ display: 'none' }} >{AppRSignal()} </div>)}

                        <div className="col-md-3" style={{
                            borderLeftColor: 'rgb(217, 217, 217)',
                            borderLeftStyle: 'solid',
                            borderLeftWidth: '1px',
                            borderLeft: '0px',
                            padding: '15px',
                            paddingRight: '25px',
                            paddingTop: '0px',
                            paddingLeft: '0px'
                        }} >
                            <div id="chatAndProDiv" style={{
                                display: isMobile ? "none" : "block"
                            }}>
                                {/* {isInterviewer ? (*/}
                                <div
                                    id="divChatMsg"
                                    style={{
                                        width: "100%",
                                        marginTop: "-3%",
                                        backgroundColor: "white"
                                    }}
                                >

                                    <div id="divMessages" className="messages"  >
                                        {getChatData != null && getChatData != undefined && getChatData.length > 0 && getChatData.map((item, index) => {
                                            return (
                                                <div key={index} style={item.userId == userid ? { textAlign: "right" } : {}}>
                                                    <div className="message-author">
                                                        {item.username}
                                                        <span style={{ fontWeight: 100 }}>
                                                            { } {item.time}
                                                        </span>
                                                    </div>
                                                    <div className="ChatDiv" style={item.userId == userid ? { marginLeft: "auto" } : {}}>
                                                        {item.message}
                                                    </div>
                                                </div>
                                            )

                                        })}

                                    </div>
                                    <div className="input-zone" style={{ position: isMobile ? "sticky" : "inherit", bottom: 0 }}>
                                        <input
                                            id="tbMessage"
                                            className="input-zone-input"
                                            style={{
                                                width: "95%",
                                                margin: 10,
                                                paddingLeft: 10,
                                                borderRadius: 6,
                                                backgroundColor: "#f7fafc",
                                                border: "1px solid #d9d9d9",
                                                lineHeight: "2.5"
                                            }}

                                            onKeyUp={e => {
                                                if (e.key === 'Enter') {
                                                    handleClick()
                                                }
                                            }
                                            }
                                            type="text"
                                            placeholder="Type your message here..."
                                        />
                                        {/*    <button id="btnSend" className="CCand" style={{ display: isInterviewer ? "" : "none" }} onClick={(event) => { SetInput("chat", "tbMessage", true); chatAdd(uriCode) }}>*/}
                                        {/*        To Candidate*/}
                                        {/*</button>*/}

                                        <ButtonGroup
                                            variant="contained"
                                            ref={anchorRef}
                                            aria-label="split button"
                                            style={{ display: isInterviewer ? "" : "none" }}
                                        >
                                            <Button style={{ padding: "6px 10px", textTransform: "inherit", fontSize: "14px" }} onClick={handleClick}>{options[selectedIndex]}</Button>
                                            <Button
                                                size="small"
                                                aria-controls={open ? 'split-button-menu' : undefined}
                                                aria-expanded={open ? 'true' : undefined}
                                                aria-label="select merge strategy"
                                                aria-haspopup="menu"
                                                onClick={handleToggle}
                                                style={{ padding: "0px", minWidth: 25 }}
                                            >
                                                <ArrowDropDownIcon />
                                            </Button>
                                        </ButtonGroup>
                                        {!isInterviewer && (
                                            <Button style={{ padding: "6px 10px", textTransform: "inherit", fontSize: "14px", background: "#1976d2", color:"#fff" }} onClick={handleClick}>SEND</Button>
                                        )}
                                        <Popper
                                            open={open}
                                            anchorEl={anchorRef.current}
                                            role={undefined}
                                            transition
                                            disablePortal
                                        >
                                            {({ TransitionProps, placement }) => (
                                                <Grow
                                                    {...TransitionProps}
                                                    style={{
                                                        transformOrigin:
                                                            placement === 'bottom' ? 'center top' : 'center bottom',
                                                    }}
                                                >
                                                    <Paper>
                                                        <ClickAwayListener onClickAway={handleClose}>
                                                            <MenuList id="split-button-menu" autoFocusItem>
                                                                {options.map((option, index) => (
                                                                    <MenuItem
                                                                        key={option}
                                                                        disabled={index === 2}
                                                                        selected={index === selectedIndex}
                                                                        onClick={(event) => handleMenuItemClick(event, index)}
                                                                    >
                                                                        {option}
                                                                    </MenuItem>
                                                                ))}
                                                            </MenuList>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                </Grow>
                                            )}
                                        </Popper>
                                    </div>
                                </div>

                                {/*)*/}
                                {/*   : (<div style={{ display: "none" }}></div>)}*/}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            {isSubstageVisible && (
                <Stack horizontal className={mediaGallerySubstageStyle}>
                    {getSubstageMediaGalleryTilesForParticipants(substageParticipants)}
                </Stack>
            )}
        </Stack>
    );
};
